import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithFilemaker_1 from '../../../../../libraries/Images/createAConnectionWithFilemaker_1.png';
import createAConnectionWithFilemaker_2 from '../../../../../libraries/Images/createAConnectionWithFilemaker_2.png';
import createAConnectionWithFilemaker_3 from '../../../../../libraries/Images/createAConnectionWithFilemaker_3.png';
import createAConnectionWithFilemaker_4 from '../../../../../libraries/Images/createAConnectionWithFilemaker_4.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithfilemaker">
                1.&nbsp;{translate('createaconnectionwithfilemaker')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "Filemaker" from among them.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_2} width="75%" />
            </Zoom>
            <p>After you click "Filemaker", please enter required values then click OK button to finish.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see a Filemaker card once the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_4} width="50%"/>
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to go through the steps in Filemaker.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);